import { roleSatisfies } from './roleRank';

export type GateInput = { isReady: boolean; token: string | null; role: string | null };
export type GateResult = 'loading' | 'signin' | 'notauthorised' | 'ok';

export function advisorGate({ isReady, token, role }: GateInput): GateResult {
  if (!isReady) return 'loading';
  if (!token) return 'signin';
  if (!roleSatisfies(role ?? '', 'advisor')) return 'notauthorised';
  return 'ok';
}
